import close from '../../assets/icons/close.svg';
import { createPortal } from 'react-dom';

/**
 * Modal listing the employees behind the "Present"/"Absent" stat cards.
 *
 * Props:
 *  - isOpen      : boolean
 *  - onClose     : () => void
 *  - status      : 'present' | 'absent'
 *  - dateLabel   : string shown in the header (e.g. "Thursday, 04 June")
 *  - employees   : array of employee objects from /staff/attendance-employees/
 *  - loading     : boolean
 */
const AttendanceEmployeeModal = ({
  isOpen,
  onClose,
  status = 'present',
  dateLabel = '',
  employees = [],
  loading = false,
}) => {
  if (!isOpen) return null;

  const isPresent = status === 'present';
  const accent = isPresent ? '#39886F' : '#B91C1C';
  const title = isPresent ? 'Present Employees' : 'Absent Employees';

  return createPortal(
    <div
      className="modal-overlay"
      style={{
        zIndex: 9999999,
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      onClick={onClose}
    >
      <div
        className="modal-content"
        style={{
          position: 'relative',
          width: '55%',
          maxWidth: '720px',
          backgroundColor: 'white',
          zIndex: 10000000,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header-content d-flex justify-content-between align-items-center mb-3">
          <h4 style={{ color: accent, margin: 0 }}>
            {title}
            {!loading && (
              <span style={{ fontSize: '16px', color: '#6B778C', marginLeft: '8px' }}>
                ({employees.length})
              </span>
            )}
            {dateLabel && (
              <span style={{ display: 'block', fontSize: '13px', color: '#6B778C', fontWeight: 400 }}>
                {dateLabel}
              </span>
            )}
          </h4>
          <button className="close-btn" onClick={onClose}>
            <img src={close} alt="close" />
          </button>
        </div>

        <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <span className="spinner-border" role="status" style={{ color: accent }} />
            </div>
          ) : employees.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#888' }}>
              No employees to show
            </div>
          ) : (
            <table className="table" style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ textAlign: 'left', color: '#6B778C', fontSize: '13px' }}>
                  <th style={{ padding: '8px' }}>#</th>
                  <th style={{ padding: '8px' }}>Employee</th>
                  <th style={{ padding: '8px' }}>Designation</th>
                  {isPresent && <th style={{ padding: '8px' }}>Punch In</th>}
                </tr>
              </thead>
              <tbody>
                {employees.map((emp, index) => (
                  <tr
                    key={`${emp.employee_id}-${index}`}
                    style={{ borderTop: '1px solid #eee' }}
                  >
                    <td style={{ padding: '8px', color: '#6B778C' }}>{index + 1}</td>
                    <td style={{ padding: '8px' }}>
                      <div style={{ fontWeight: 500, color: 'rgb(34, 47, 62)' }}>
                        {emp.employee_name || '-'}
                      </div>
                      <small style={{ color: '#6B778C' }}>{emp.unique_code}</small>
                    </td>
                    <td style={{ padding: '8px' }}>{emp.designation || '-'}</td>
                    {isPresent && (
                      <td style={{ padding: '8px', fontWeight: 500 }}>
                        {emp.punch_in || '-'}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AttendanceEmployeeModal;
